// @ts-nocheck

import React, { useCallback, useEffect, useState } from 'react';
import styled from 'styled-components';
import moment from 'moment';

import Button from 'antd/lib/button';
import notification from 'antd/lib/notification';

import {
  fuelsAndOilsMechanismApi,
  vehiclePlanApi } from
'../../../../../lib/api';




import { calculationStatusEnum, fuelTypes } from '../../../../../lib/enum';
import {
  toLocalStringRu,
  withEmptyRow,
  formatRub,
  plus } from
'../../../../../lib/helpers';
import { Section } from '../../../../../components/layout';

import { Popconfirm, AntTable, Icon } from '../../../../../components/ui';
import { notificationLoading } from '../../../../../components/Notifications';

import { MONTH } from '../../lib';
import { headerPanel } from '../../components/Common';
import { ModalFuelAndOilMechanism } from './MechanismsModal';





const StyledIcon = styled(Icon)`
  cursor: pointer;
`;

export default (props) => {
  const [data, setData] = useState([]);
  const [vehiclePlan, setVehiclePlan] = useState({});
  const [currentRowId, setCurrentRowId] = useState(-1);
  const [visibleData, setVisibleData] = useState([]);
  const [modalVisible, setModalVisible] = useState(false);
  const [readOnly, setReadOnly] = useState(true);

  const columns = [
  {
    title: 'Наименование средства малой механизации',
    dataIndex: 'smallScaleMechanizationTool.name',
    width: '400px'
  },
  {
    title: 'Марка топлива',
    dataIndex: 'type',
    render: (type) => fuelTypes[type]
  },
  ...MONTH.map((month, index) => ({
    title: month.title,
    children: [
    {
      title: 'Количество, л.',
      dataIndex: `months[${index}].count`,
      render: (count, row) => row.id ? toLocalStringRu(count) : null
    },
    {
      title: 'Стоимость',
      dataIndex: `months[${index}].cost`,
      render: (count, row) => row.id ? formatRub(count) : null
    }]

  })),
  {
    title: 'Итого',
    render: (record) => {
      let sum = 0;
      if (Array.isArray(record.months)) {
        record.months.forEach((month) => {
          sum = plus(sum, month.cost);
        });
      }
      return formatRub(sum);
    }
  },
  {
    key: 'delete',
    dataIndex: 'id',
    width: '50px',
    onCell: () => ({ onClick: (e) => e.stopPropagation() }),
    render: (id, record, rowIndex) => {
      return (
        Number.isInteger(id) &&
        !readOnly &&
        <Popconfirm
          placement="topRight"
          title="Вы действительно хотите удалить?"
          okText="Да"
          cancelText="Нет"
          onConfirm={() => onDelete(id, rowIndex)}>

              <StyledIcon type="x" />
            </Popconfirm>);


    }
  }];


  const fetch = useCallback(async () => {
    try {
      const { data } = await fuelsAndOilsMechanismApi.fetch({
        vehiclePlanId: props.vehiclePlanId
      });

      setData(data);
    } catch (e) {
      notification.error({ message: 'Ошибка', description: e.message });
    }
  }, [props.vehiclePlanId]);

  const fetchVehiclePlan = useCallback(async () => {
    try {
      const vehiclePlan = await vehiclePlanApi.get(props.vehiclePlanId);
      setVehiclePlan(vehiclePlan);
    } catch (e) {
      notification.error({ message: 'Ошибка', description: e.message });
    }
  }, [props.vehiclePlanId]);

  const update = useCallback(
    async (dataRow) => {
      try {
        let newData = [...data];
        if (dataRow.id) {
          const updatedData = await fuelsAndOilsMechanismApi.update(dataRow);
          newData[currentRowId] = updatedData;
        } else {
          const addedData = await fuelsAndOilsMechanismApi.add(dataRow);
          newData.push(addedData);
        }
        setData(newData.filter((data) => !!data.id));
      } catch (e) {
        notification.error({ message: 'Ошибка', description: e.message });
      }
    },
    [currentRowId, data]
  );

  const onDelete = async (id, rowIndex) => {
    try {
      notificationLoading({
        message: 'Удаление записи...',
        key: 'delete'
      });
      await fuelsAndOilsMechanismApi.delete(id);
      data.splice(rowIndex, 1);
      setData([...data]);
    } catch (error) {
      notification.error({
        message: 'Ошибка',
        description: error.message
      });
    } finally {
      notification.destroy('delete');
    }
  };

  useEffect(() => {
    fetchVehiclePlan();
    fetch();
  }, [fetch, fetchVehiclePlan]);

  useEffect(() => {
    setReadOnly(
      vehiclePlan?.fuelAndOilMechanismCalculationStatus ===
      calculationStatusEnum.calculationDone
    );
  }, [vehiclePlan]);

  const onAdd = useCallback(() => {
    setCurrentRowId(data.length);
    setData([
    ...data,
    {
      type: null,
      name: '',
      months: MONTH.map((el, index) => {
        return {
          month: index + 1,
          count: 0,
          cost: 0
        };
      }),
      vehiclePlanId: props.vehiclePlanId
    }]
    );
    setModalVisible(true);
  }, [data, props.vehiclePlanId]);

  const itog = (data) => {
    let itog = {
      id: true,
      smallScaleMechanizationTool: { name: 'Итого:' },
      months: Array(12).
      fill().
      map(() => ({ cost: 0 }))
    };
    data.forEach((mechamism) =>
    mechamism.months.forEach(
      (month, index) => {
        itog.months[index].cost = plus(itog.months[index].cost, month.cost);
      }
    )
    );
    return itog;
  };

  useEffect(() => {
    setVisibleData(
      readOnly ?
      data.length === 0 ?
      [] :
      [...data, itog(data)] :
      withEmptyRow(data.length === 0 ? [] : [...data, itog(data)], {
        emptyRow: {
          smallScaleMechanizationTool: {
            name:
            <Button size="small" onClick={onAdd}>
                    Добавить
                  </Button>

          }
        }
      })
    );
  }, [data, onAdd, readOnly]);

  const onAddCancel = () => {
    setModalVisible(false);
    let newData = [...data];
    newData[currentRowId].id ?? newData.pop();
    setData(newData);
    setCurrentRowId(-1);
  };

  const changeStatus = async () => {
    const { vehiclePlanId } = props;
    try {
      notificationLoading({
        message: 'Сохранение данных',
        key: 'saving'
      });
      await fuelsAndOilsMechanismApi.changeStatus(
        vehiclePlanId,
        calculationStatusEnum.calculationDone
      );
      fetch();
      fetchVehiclePlan();
    } catch (error) {
      notification.error({ message: 'Не удалось обновить данные данные' });
    } finally {
      notification.destroy('saving');
    }
  };

  const isDraft = () =>
  vehiclePlan?.fuelAndOilMechanismCalculationStatus ===
  calculationStatusEnum.draft;

  const isRangeMonths = (monthIndex) => {
    if (vehiclePlan?.startDate && vehiclePlan?.endDate) {
      const start = moment(vehiclePlan.startDate).get('month');
      const end = moment(vehiclePlan.endDate).get('month');
      return start <= monthIndex && end >= monthIndex;
    }
    return false;
  };

  return (
    <>
      {headerPanel({
        vehiclePlanId: props.vehiclePlanId,
        title: 'Средства малой механизации',
        passTab: true
      })}
      <Section>
        <AntTable
          onRow={(record, rowIndex) => ({
            onClick: async () => {
              if (Number.isInteger(record.id)) {
                await setCurrentRowId(rowIndex);
                setModalVisible(true);
              }
            }
          })}
          columns={columns}
          data={visibleData}
          pagination={false}
          rowKey="name"
          bordered
          scroll={{
            x: 5000,
            y: 'calc(100vh - 400px)'
          }} />

        <ModalFuelAndOilMechanism
          visible={modalVisible}
          isRangeMonths={isRangeMonths}
          handleSave={(data) => {
            setModalVisible(false);
            update(data);
            setCurrentRowId(-1);
          }}
          handleCancel={onAddCancel}
          data={visibleData[currentRowId]}
          readOnly={readOnly} />

      </Section>
      {isDraft() &&
      <Section style={{ padding: '16px' }}>
          <Button
          style={{ marginLeft: '16px' }}
          type="primary"
          onClick={changeStatus}>

            Утвердить
          </Button>
        </Section>
      }
    </>);

};
